import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import {useSelector} from "react-redux";
import * as Yup from "yup";
import * as businessesCrud from '../../../_redux/businesses/businessesCrud';
import helper_funcs from "../../../../helper_funcs.js";

// Validation schema
const BusinessEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),

});
export function BusinessCoverImagesForm({
  business,
  btnRef,
  saveBusiness,
  businessCoverImagePage,
}) {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }

  var [isloading, setIsLoading] = useState(false);
  const [rep_business_images, setRepBusinessImages] = useState([]);
  const [is_report, setIsReport] = useState(false);

  useEffect(() => {
    if(business.report_business!=null)
    {
      let report_fields = JSON.parse(business.report_business.report_fields)
      if(business.report_business.is_report)  { setIsReport(business.report_business.is_report)}
      if(report_fields.business_images_rep && report_fields.business_images_rep.length>0){setRepBusinessImages(report_fields.business_images_rep)}
    }
  }, [business]);

  const deleteImage = async (event, item) => {
    event.preventDefault();
    try {
      await helper_funcs.deleteImage(item.image_url);
      await businessesCrud.deleteImages(item);
      businessCoverImagePage();
    } catch (err) {
      console.error("Delete image failed:", err);
      alert("Failed to delete image. Please try again.");
    }
  }

  const fileSelected = async (event,business) => {
    document.getElementById('icon').click();
    document.getElementById('icon').onchange = async (e) => {
      setIsLoading(true);
      const files = e.target.files;
      if (!files || files.length === 0) {
        setIsLoading(false);
        return alert("Please choose at least one file to upload.");
      }
      for(let i=0; i<files.length; i++) {
        const file = files[i];
        const upload = helper_funcs.upload_specific_file(file, business);
        try {
          const data = await upload.promise();
          let businessImage = {};
          businessImage.id = business.id;
          businessImage.image = data.Location;
          businessImage.key = data.key;
          await businessesCrud.UploadCoverImages(businessImage);
        } catch(err) {
          console.error(err);
        }
      }
      businessCoverImagePage();
      setIsLoading(false);
    }
  }
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={business}
        validationSchema={BusinessEditSchema}
        onSubmit={(values) => {
          saveBusiness(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Form className="form form-label-right" style={{ overflow: "visible" }}>
              <div id="image-div" className="business-images-grid" style={{ display: "flex", flexWrap: "wrap", gap: "1.75rem", alignItems: "flex-start", overflow: "visible", padding: "0.5rem 0" }}>
                {(business.business_cover_images || []).map((item, index) => (
                  <div key={`cover-${index}`} className="business-image-card" style={{ flexShrink: 0, position: "relative", width: "200px", height: "200px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", border: "1px solid #E4E6EF", backgroundColor: "#fff" }}>
                    <div style={{ overflow: "hidden", borderRadius: "7px", width: "100%", height: "100%" }}>
                      <img name={`business_cover_images[${index}].image`} src={helper_funcs.get_signed_url(business.userid,item.image_url)} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} alt="" />
                    </div>
                    <button type="button" className="btn btn-sm btn-danger" style={{ position: "absolute", top: "8px", right: "8px", left: "auto", bottom: "auto", zIndex: 10, margin: 0 }} onClick={(e) => deleteImage(e, item)}>Delete</button>
                    <input 
                      type="number" 
                      defaultValue={item.image_order || 0} 
                      onBlur={(e) => businessesCrud.updateImageOrder(item.id, e.target.value)} 
                      style={{ position: "absolute", bottom: "8px", right: "8px", width: "60px", textAlign: "center", zIndex: 10, border: "1px solid #ccc", borderRadius: "4px" }} 
                      title="Image Order"
                    />
                    {superadmin && is_report && rep_business_images.includes(item.id) && (
                      <button type="button" className="btn btn-sm btn-warning" style={{ position: "absolute", top: "8px", right: "64px", left: "auto", bottom: "auto", zIndex: 10, margin: 0 }}>Reported</button>
                    )}
                  </div>
                ))}
                <div className="business-image-upload-card" style={{ width: "200px", height: "200px", minWidth: "200px", minHeight: "200px", border: "2px dashed #D1D3E0", borderRadius: "8px", alignItems: "center", display: "flex", justifyContent: "center", flexShrink: 0, backgroundColor: "#F9F9FB", boxSizing: "border-box" }}>
                  <input id="icon" type="file" multiple accept="image/*" style={{ display: "none" }} />
                  <a href="#/" onClick={e => { e.preventDefault(); fileSelected(e, business); }} style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", textDecoration: "none", color: "inherit" }}>
                    {(isloading) ? (
                      <div className="spinner spinner-lg spinner-success" />
                    ) : (
                      <span className="btn btn-outline-primary btn-sm">Upload Image</span>
                    )}
                  </a>
                </div>
              </div>
              <button
                style={{ display: "none" }}
                type="submit"
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              >Submit</button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
